import React, { useMemo } from "react";
import PopUp from "../PopUp";
import { WrapperQuiz } from "../Quiz";
import { useQuizContext } from "../../context/QuizContext";
import { useLocaleContext } from "../../context/LocaleContext";
import { usePollsContext } from "../../context/PollsContext";
import { useModalContext } from "../../context/ModalContext";
import { useWidgetContext } from "../../context/WidgetContextProvider";
import QuizPartner from "../Quiz/QuizPartner";
import ConfirmationModal from "../ConfirmationModal";

import "./style.scss";

export default ({ }) => {
    const { activeQuizKey, onCloseQuiz, quiz } = useQuizContext();
    const { answeredPollIds } = usePollsContext();
    const $locale = useLocaleContext();
    const { renderModal } = useModalContext();
    const { isWidget } = useWidgetContext();

    const isQuizCompleted = useMemo(() => {
        return quiz?.polls.every(({ id }) =>  answeredPollIds.includes(id));
    }, [quiz, answeredPollIds]);

    const onCloseCheck = () => {
        return new Promise((resolve) => {
            const isPassedQuiz = quiz.polls.every(({ id }) => answeredPollIds.includes(id));
            if (!isPassedQuiz) {
                renderModal(
                    ConfirmationModal,
                    {
                        $locale,
                        title: 'quiz.confirmationClose.title',
                        onClose: (props) => resolve(props?.isConfirmed),
                        lockPageScroll: false,
                    },
                );
            } else {
                resolve(true);
            }
        });
    };

    if (isQuizCompleted && !activeQuizKey) {
        return null;
    }

    return (
        <PopUp
            isOpen={!!quiz}
            onClose={() => onCloseQuiz(quiz.id)}
            onCloseCheck={onCloseCheck}
            isCloseOut
            isMoving
            isWidget={isWidget}
            header={quiz?.partners?.length > 0 && (
                <div className="quiz-modal-partners">
                    {quiz?.partners.map((partner) => (
                        <QuizPartner key={partner.id} partner={partner} />
                    ))}
                </div>
            )}
            title={<div className="quiz-modal-title">{$locale.getProperty(quiz, "title")}</div>}
        >
            <WrapperQuiz isShowHeader={false} />
        </PopUp>
    );
}